import _ from 'lodash';

const emptyStoryMetrics = () => [{
  exits: null,
  impressions: null,
  reach: null,
  replies: null,
  taps_forward: null,
  taps_back: null,
  createdDate: new Date(),
}];

/**
 * Maps a modal story (from the enriched story-service response) to `stories`
 * attributes — mirrors how the scanner writes an unauthorized-scan story.
 * Relationships (campaign/discussion) are set on the resource by the caller.
 */
const buildStoryAttributes = (story, { discussionName, createdBy }) => {
  const isIg = story.platform === 'INSTAGRAM';
  const attributes = {
    assetId: story.assetId,
    assetURL: story.assetUrl || story.linkUrl,
    platform: story.platform,
    assetType: story.assetType || (story.hasVideo ? 'VIDEO' : 'IMAGE'),
    username: (story.handle || '').replace(/^@/, ''),
    publishedDate: story.takenAt,
    savedThumbnailUrl: story.thumbnailUrl,
    captionCaptured: !!story.caption,
    mediaCaptured: false,
    status: 'LIVE_UNAUTHORIZED',
    createdSource: 'ALL_STORIES_MODAL',
    createdBy,
    createdDate: new Date(),
    storyData: emptyStoryMetrics(),
    discussionName,
  };
  if (story.caption) attributes.caption = story.caption;
  if (!_.isEmpty(story.hashtags)) attributes.hashtags = story.hashtags.join(',');
  if (!_.isEmpty(story.mentions)) attributes.mentions = story.mentions.join(',');
  if (isIg) {
    attributes.instagramId = story.id;
    attributes.facebookId = story.id;
    if (story.accountId) attributes.instagramAccountId = story.accountId;
  } else if (story.tiktokId) {
    attributes.tiktokId = story.tiktokId;
  }
  return attributes;
};

export default buildStoryAttributes;



/** WEBPACK FOOTER **
 ** ./src/components/all-stories-modal/build-story-payload.js
 **/